import { DizionarioModel } from '../shared/dizionario.model';
export class IncassoAssegniListItemModel {
  id:number;
  token: string;
  nomeBanca: string;
  abi?: string;
  cab?: string;
  numeroAssegno: string;
  tipoAssegno: DizionarioModel;
  dataAssegno: Date;
  importo: number;
  flagAssegnoVerificato?:boolean;
  imgFronte: FormData; //specifici client
  imgRetro: FormData;  //specifici client
}





// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/incassi/incasso-assegni-list-item.model.ts